<script lang="ts" setup>
import { ref } from 'vue';
import { minLength } from '../../rules/index';
import { UserToCreate } from '../NewUser/useCreateMultipleUsers';
import { useLocale } from '../../composables/useLocale';

type Props = {
  user: UserToCreate;
  disabled: boolean;
};

const props = defineProps<Props>();

type Emits = {
  (e: 'update', userKey: string, value: string | undefined): void;
};

const emit = defineEmits<Emits>();

const { t } = useLocale();

const textValue = ref();
const model = defineModel<string | undefined>();

const onModelUpdate = () => {
  emit('update', props.user.key, model.value);
};

defineExpose({
  isValid: () => textValue.value.isValid,
});
</script>

<template>
  <v-row>
    <v-col>
      <h4>
        {{ t('lcp.required_name', { name: user.name, role: user.role }) }}
      </h4>
      <p>{{ t('lcp.required_name_info') }}</p>
    </v-col>
  </v-row>
  <v-row class="mt-3">
    <v-col>
      <v-text-field
        ref="textValue"
        label="name"
        :rules="[minLength(3, t)]"
        v-model="model"
        variant="outlined"
        :disabled="disabled"
        @update:modelValue="onModelUpdate"
        validate-on="eager"
      ></v-text-field>
    </v-col>
  </v-row>
</template>
